import { Link } from "react-router-dom";

export default function Logo({ compact = false, className = "" }) {
  return (
    <Link to="/" className={`inline-flex flex-col leading-none ${className}`} data-testid="logo-link">
      <span className="font-display font-bold tracking-tight text-white text-xl md:text-[22px]">
        Lahden Autokulma
      </span>
      <span
        className="h-[3px] bg-[#ff5a00] my-[3px] text-xl md:text-[22px]"
        style={{ marginRight: "-0.0975em" }}
      />
      {!compact && (
        <span className="font-mono text-[8px] md:text-[9px] uppercase tracking-[0.22em] text-white/80 text-center">
          käytettyjen autojen erikoisliike
        </span>
      )}
    </Link>
  );
}
